goog.provide('el8.tourguide.tease');

goog.require('el8.appchart.showItemDetail');
goog.require('el8.ptdata.fetch');
goog.require('el8.template.tourguide.tease');
goog.require('el8.tourguide.Guide');
goog.require('el8.tourguide.Hilite');
goog.require('el8.tourguide.HiliteAction');
goog.require('el8.tourguide.InfoBox');
goog.require('el8.tourguide.Shade');
goog.require('el8.tourguide.Slide');
goog.require('el8.tourguide.Splash');
goog.require('el8.util.dom');

if (typeof(_gaq) === "undefined") { _gaq = []; }

el8.tourguide.tease = (function() {

    if (!el8Globals['TEASE']) { return null; }

    // State variable
    var noItemDetail = false;
    function setNoItemDetail(state) {
        if (state) { // truthy
            $('.itemTrigger, .viewDocTrigger').addClass('noHover');
            noItemDetail = true;
        } else {
            $('.itemTrigger, .viewDocTrigger').removeClass('noHover');
            noItemDetail = false;
        }
    }

    var guide = new el8.tourguide.Guide({
        visorOpts: {
            height: el8Globals['TOUR_VISOR_HEIGHT'],
            contentFn: el8.template.tourguide.tease.visorContent,
            slideNavContentFn: el8.template.tourguide.tease.visorSlideNav,
            clickTriggerMap: {
                '.progress-trigger': function(e) {
                    var $target = $(e.target);
                    if (!guide.isInProgress()) {
                        guide.enter();
                    }
                    guide.jumpToName($target.attr('_name'), true);
                }
            }
        },
        startFn: function() {
            guide.jumpTo(0);
        },
        enterFn: function() {
            $('#chart-feed-more-trigger').prop('disabled', true);
            hideSearchInfoBox();
            unhoverTimelineInfoBox();
            el8.appchart.dialog.reports.hide(); // will trigger an event that by this point is no longer attached
        },
        endFn: function() {
            $('#chart-feed-more-trigger').prop('disabled', false);
            hoverTimelineInfoBox();
            el8.appchart.dialog.reports.hide(); // will trigger an event that by this point is no longer attached
        },
        hasSplashPage: true,
        splashStartBtnFn: function() { return 'Start'; }, // XSS OK -KF
        splashStartFn: function() {
            // Manual munging
            guide.hideLHS();
            $('.refresh-req-action-trigger').hide();
            el8.tourguide.chartInfoSplash.show();
            showChartInfoBox();
            // when we close the chartInfoSplash, we'll trigger chart-splash-close;
            // we bind to that event below and call guide.start() in response
        }
    });

    guide.hideLHS = function() {
        $('a, button', $('#refBoard')).unbind('click').on('click', function() {
            var $this = $(this);
            if ($this.hasClass('show-needs-xwalk-trigger') ||
                $this.hasClass('add-problem-trigger')) {
                    return true;
            }
            if ($this.closest('.el8ProblemList').length && $this.hasClass('edit-text-trigger')) {
                    $(document).trigger('problem-click');
                    return true;
            }
            endSplash.show();
            return false;
        });
    };

    var searchInfoBox = null;
    function showSearchInfoBox() {
        var $elt = $('#chart-feed-search-input');
        if (!searchInfoBox) {
            searchInfoBox = new el8.tourguide.InfoBox();
            searchInfoBox.show({
                contentFn: el8.template.tourguide.tease.exploreSearch,
                height: 100,
                width: 250,
                left: $elt.parent().offset().left - 250 - 20,
                top: $elt.parent().offset().top - 10
            });
        }
        el8.appchart.mainFeeds.chart.focusInput();
    }
    function hideSearchInfoBox() {
        if (searchInfoBox) {
            searchInfoBox.hide(true);
            searchInfoBox = null;
        }
    }

    var timelineInfoBox = null;
    function showTimelineInfoBox() {
        if (!timelineInfoBox) {
            var $elt = $("#chart-feed-visual");

            if ($elt.length) {
                timelineInfoBox = new el8.tourguide.InfoBox();
                timelineInfoBox.show({
                    contentFn: el8.template.tourguide.tease.timeline,
                    height: 95,
                    width: 250,
                    left: $elt.offset().left + 150,
                    top: $elt.offset().top + $elt.outerHeight(true) + 10,
                });
            }
        }
    }
    function hideTimelineInfoBox() {
        if (timelineInfoBox) {
            timelineInfoBox.hide(true);
            timelineInfoBox = null;
        }
    }

    var chartInfoBox = new el8.tourguide.InfoBox();
    function showChartInfoBox() {
        var $splashElt = el8.tourguide.chartInfoSplash.getContentElt();
        var position = getChartInfoBoxPosition();
        chartInfoBox.show({
            contentFn: el8.template.tourguide.tease.chartInfoSplash,
            height: 45,
            width: 160,
            left: position.left,
            top: position.top,
            zIndex: $splashElt.css('z-index') + 1
        });
        el8.app.pageLayout.addResizeListener(repositionChartInfoBox);
    }
    function hideChartInfoBox() {
        chartInfoBox.hide();
        el8.app.pageLayout.removeResizeListener(repositionChartInfoBox);
    }
    function repositionChartInfoBox() {
        chartInfoBox.adjustOffsets(getChartInfoBoxPosition());
    }
    function getChartInfoBoxPosition() {
        var $splashElt = el8.tourguide.chartInfoSplash.getContentElt();
        var $trigger = $('.close-trigger', $splashElt);
        return {
            left: $trigger.offset().left - 175,
            top: $trigger.offset().top
        };
    }

    /**
     * Slide: ICD-10 Crosswalk Notifier
     */
    var xwalkNotifierWidget = new el8.tourguide.InfoBox();
    var xwalkNotifierHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var slideXwalkNotifier = new el8.tourguide.Slide({
        navCaption: '1. Search Problems',
        name: 'xwalkNotifier',
        showFn: function() {
            var $elt = $('#problem-section');
            try {
                $elt.scrollintoview({ duration: 0});
            } catch (e) {}
            xwalkNotifierWidget.show({
                contentFn: el8.template.tourguide.tease.xwalkNotifier,
                height: 150,
                width: 320,
                left: $elt.width(),
                top: $elt.offset().top + 20
            });
            xwalkNotifierHilite.show($elt, el8Globals['TOUR_VISOR_HEIGHT'], {
                top: 2,
                bottom: 5,
                right: 5,
                left: 5
            });
            $('#refBoardContainer').css({'overflow': 'hidden'});
        },
        hideFn: function() {
            xwalkNotifierWidget.hide();
            xwalkNotifierHilite.hide();
            $('#refBoardContainer').css({'overflow': 'auto'});
        },
        eventToSlideNameMap: {
            'problem-click': 'problemDialog'
         }
    });
    guide.addSlide(slideXwalkNotifier);

    /**
     * Slide: First instance of the problem dialog
     */
    var problemDialogWidget = new el8.tourguide.InfoBox();
    var problemDialogHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var slideProblemDialog = new el8.tourguide.Slide({
        name: 'problemDialog',
        showFn: function() {
            el8.appchart.dialog.addEditProblem.show();
            var $dialog = el8.appchart.dialog.addEditProblem.getDialogContainer();
            var widgetHeight = 95;
            var widgetWidth = 310;
            problemDialogWidget.show({
                contentFn: el8.template.tourguide.tease.problemDialog,
                height: widgetHeight,
                width: widgetWidth,
                left: $dialog.offset().left + widgetWidth/2,
                top: $dialog.offset().top - widgetHeight - 5,
                zIndex: 5000
            });
            problemDialogHilite.show($dialog, el8Globals['TOUR_VISOR_HEIGHT']);
        },
        hideFn: function() {
            problemDialogWidget.hide();
            problemDialogHilite.hide();
        },
        eventToSlideNameMap: {
            'problem-dialog-crosswalk-another': 'problemDialogXwalkAnother',
            'problem-dialog-final-close': 'searchCholesterol'
        }
    });
    guide.addSlide(slideProblemDialog);

    /**
     * Slide: Subsequent instances of the problem dialog
     */
    var problemDialogXwalkAnotherWidget = new el8.tourguide.InfoBox();
    var slideProblemDialogXwalkAnother = new el8.tourguide.Slide({
        name: 'problemDialogXwalkAnother',
        showFn: function() {
            var $dialog = el8.appchart.dialog.addEditProblem.getDialogContainer();
            var widgetHeight = 95;
            var widgetWidth = 310;
            problemDialogXwalkAnotherWidget.show({
                contentFn: el8.template.tourguide.tease.problemDialogXwalkAnother,
                height: widgetHeight,
                width: widgetWidth,
                left: $dialog.offset().left + widgetWidth/2,
                top: $dialog.offset().top - widgetHeight,
                zIndex: 5000
            });
            problemDialogHilite.show($dialog, el8Globals['TOUR_VISOR_HEIGHT']);
        },
        hideFn: function() {
            problemDialogXwalkAnotherWidget.hide();
            problemDialogHilite.hide();
        },
        eventToSlideNameMap: {
            'problem-dialog-crosswalk-another': 'problemDialogXwalkAnother',
            'problem-dialog-final-close': 'searchCholesterol'
        }
    });
    guide.addSlide(slideProblemDialogXwalkAnother);

    /**
     * Slide: Search cholesterol
     */
    var searchCholesterolWidget = new el8.tourguide.InfoBox();
    var searchCholesterolHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var slideSearchCholesterol = new el8.tourguide.Slide({
        navCaption: '2. Search Labs',
        name: 'searchCholesterol',
        showFn: function() {
            $('#main-feed-container')
                .scrollTo('0%')
                .css({'overflow': 'hidden'})
                .trigger('scroll');
            var $elt = $('#chart-feed-search-input');

            if ( $elt.length) {
                searchCholesterolWidget.show({
                    contentFn: el8.template.tourguide.tease.searchCholesterol,
                    height: 120,
                    width: 320,
                    left: $elt.parent().offset().left,
                    top:
                        $elt.parent().offset().top +
                        $elt.parent().outerHeight(true) +
                        10,
                });
                el8.appchart.mainFeeds.chart.setFilterFieldVal("cholesterol");
                el8.appchart.mainFeeds.chart.focusInput();
                searchCholesterolHilite.show(
                    $elt.parent(),
                    el8Globals["TOUR_VISOR_HEIGHT"],
                    {
                        top: 5,
                        bottom: 5,
                        right: 5,
                        left: 5,
                    }
                );
            }

        },
        hideFn: function() {
            searchCholesterolWidget.hide();
            searchCholesterolHilite.hide();
            $('#chart-feed-search-input').trigger('blur');
            $('#main-feed-container').css({'overflow': 'auto'});
        },
        eventToSlideNameMap: {
            'successful-cholesterol-search': 'cholesterolResults1',
            'failed-cholesterol-search': 'searchCholesterolAgain',
            'failed-chart-feed-search': 'searchCholesterolAgain',
            'cleared-chart-feed-search': 'searchCholesterol'
         }
    });
    guide.addSlide(slideSearchCholesterol);

    /**
     * Slide: Search cholesterol again (after failure)
     */
    var searchCholesterolAgainWidget = new el8.tourguide.InfoBox();
    var searchCholesterolAgainHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var slideSearchCholesterolAgain = new el8.tourguide.Slide({
        name: 'searchCholesterolAgain',
        showFn: function() {
            $('#main-feed-container')
                .scrollTo('0%')
                .css({'overflow': 'hidden'})
                .trigger('scroll');
            var $elt = $('#chart-feed-search-input');

            if ( $elt.length ) {
                searchCholesterolAgainWidget.show({
                    contentFn:
                        el8.template.tourguide.tease.searchCholesterolAgain,
                    height: 125,
                    width: 250,
                    left: $elt.parent().offset().left,
                    top:
                        $elt.parent().offset().top +
                        $elt.parent().outerHeight(true) +
                        10,
                });
                el8.appchart.mainFeeds.chart.focusInput();
                searchCholesterolAgainHilite.show(
                    $elt.parent(),
                    el8Globals["TOUR_VISOR_HEIGHT"],
                    {
                        top: 5,
                        bottom: 5,
                        right: 5,
                        left: 5,
                    }
                );
            }
        },
        hideFn: function() {
            searchCholesterolAgainWidget.hide();
            searchCholesterolAgainHilite.hide();
            $('#main-feed-container').css({'overflow': 'auto'});
        },
        eventToSlideNameMap: {
            'successful-cholesterol-search': 'cholesterolResults1',
            'failed-cholesterol-search': 'searchCholesterolAgain',
            'failed-chart-feed-search': 'searchCholesterolAgain',
            'cleared-chart-feed-search': 'searchCholesterol'
        }
    });
    guide.addSlide(slideSearchCholesterolAgain);

    /**
     * Slide: Explain magic table
     */
    var cholesterolResultsWidget1 = new el8.tourguide.InfoBox();
    var cholesterolResultsHilite1 = new el8.tourguide.HiliteAction({'zIndex': 4});
    var cholesterolResultsShade1 = new el8.tourguide.Shade();
    var slideCholesterolResults1 = new el8.tourguide.Slide({
        name: 'cholesterolResults1',
        showFn: function() {
            $('#main-feed-container').css({'overflow': 'hidden'});
            var $magicTable = $('.lab-results-table', $('#lab-results-table-holder'));
            // Temporarily hide this super confusing note
            $('.systemNoteContainer', $magicTable).hide();
            cholesterolResultsWidget1.show({
                contentFn: el8.template.tourguide.tease.cholesterolResultsMagicTable,
                height: 125,
                width: 280,
                left: $magicTable.offset().left - 280 - 15,
                top: $magicTable.find('.magic-table-row:first').offset().top - 13
            });
            cholesterolResultsHilite1.show($magicTable, el8Globals['TOUR_VISOR_HEIGHT'], {
                bottom: 6
            });
            cholesterolResultsShade1.show($('body'), {'opacity': 0, 'zIndex': 5, 'top': el8Globals['TOUR_VISOR_HEIGHT'], 'backgroundColor': 'black'});
            $('#chart-feed-search-input').blur();
        },
        hideFn: function() {
            cholesterolResultsWidget1.hide();
            cholesterolResultsHilite1.hide();
            cholesterolResultsShade1.hide();
            $('#main-feed-container').css({'overflow': 'auto'});
            var $magicTable = $('.lab-results-table', $('#lab-results-table-holder'));
            $('.systemNoteContainer', $magicTable).show();
        }
    });
    guide.addSlide(slideCholesterolResults1);

    /**
     * Slide: Explain chart feed search results
     */
    var cholesterolResultsWidget2 = new el8.tourguide.InfoBox();
    var cholesterolResultsHilite2 = new el8.tourguide.HiliteAction({'zIndex': 4});
    var cholesterolResultsScrollFn = null;
    var slideCholesterolResults2 = new el8.tourguide.Slide({
        name: 'cholesterolResults2',
        showFn: function() {
            var $magicTable = $('.lab-results-table', $('#lab-results-table-holder'));
            var $scrollTop = $magicTable.find('.magic-table-row').eq(4);
            if ($scrollTop.length) { $('#main-feed-container').scrollTo($scrollTop); }

            setNoItemDetail(true);
            var $chartFeed = $('#chart-feed-list');
            cholesterolResultsWidget2.show({
                contentFn: el8.template.tourguide.tease.cholesterolResults,
                height: 165,
                width: 285,
                left: $chartFeed.offset().left - 285 - 10,
                top: $chartFeed.offset().top
            });
            var showHilite = function() {
                var $navigator =
                    $('.chart-feed-navigator', $('#chart-feed-navigator-holder'));
                var topBuffer = 0;

                var offsetPlusHeight =
                    $navigator.offset().top +
                    ($navigator.outerHeight(true) || 0);

                if (offsetPlusHeight > $chartFeed.offset().top) {
                    topBuffer =
                        -1 * (offsetPlusHeight - $chartFeed.offset().top);
                }

                cholesterolResultsHilite2.show($chartFeed, el8Globals['TOUR_VISOR_HEIGHT'],
                    {'top': topBuffer},
                    {'right': 15},
                    {'east': true, 'south': true}
                );

                cholesterolResultsWidget2.adjustOffsets(
                    {'top': $chartFeed.offset().top - topBuffer}
                );
            };
            showHilite();
            cholesterolResultsScrollFn = function() {
                cholesterolResultsHilite2.hide();
                showHilite();
            };
            $('#main-feed-container').on('scroll', cholesterolResultsScrollFn);
        },
        hideFn: function() {
            cholesterolResultsWidget2.hide();
            cholesterolResultsHilite2.hide();
            setNoItemDetail(false);
            $('#main-feed-container').off('scroll', cholesterolResultsScrollFn);
        }
    });
    guide.addSlide(slideCholesterolResults2);

    /**
     * Slide: Explain search results
     */
    var cholesterolResultsWidget3 = new el8.tourguide.InfoBox();
    var cholesterolResultsHilite3 = new el8.tourguide.HiliteAction({'zIndex': 4});
    var cholesterolResult = null;
    var slideCholesterolResults3 = new el8.tourguide.Slide({
        name: 'cholesterolResults3',
        showFn: function() {
            el8.appchart.mainFeeds.chart.scrollToTop();
            $('#main-feed-container').css({'overflow': 'hidden'});
            var $magicTable = $('.lab-results-table', $('#lab-results-table-holder'));
            cholesterolResult = $magicTable.find('.magic-table-row:last').find('.item-details-trigger:first').parent();
            if (cholesterolResult.length) {
                cholesterolResult.addClass('tourActionBorder');
                cholesterolResult.on('click', function(e) {
                    var $target = $(this).find('.item-details-trigger');
                    var id = $target.data('id');
                    el8.appchart.showItemDetail(id);
                    return false;
                });
            }
            cholesterolResultsWidget3.show({
                contentFn: el8.template.tourguide.tease.cholesterolResultClick,
                height: 75,
                width: 230,
                left: cholesterolResult.offset().left,
                top: cholesterolResult.offset().top + cholesterolResult.outerHeight(true) + 15
            });
            if (cholesterolResult.length) {
                cholesterolResultsHilite3.show(cholesterolResult, el8Globals['TOUR_VISOR_HEIGHT'], 5);
            }
        },
        hideFn: function() {
            cholesterolResultsWidget3.hide();
            cholesterolResultsHilite3.hide();
            if (cholesterolResult) {
                cholesterolResult.removeClass('tourActionBorder');
                cholesterolResult.unbind('click'); // can freely unbind because doesn't have other events
            }
            $('#main-feed-container').css({'overflow': 'auto'});
        },
        eventToSlideNameMap: {
            'show-reports-overlay': 'reportsOverlay'
        }
    });
    guide.addSlide(slideCholesterolResults3);

    /**
     * Slide: Report overlay
     */
    var reportsOverlayWidget = new el8.tourguide.InfoBox();
    var reportsOverlayShade = new el8.tourguide.Shade();
    var slideReportsOverlay = new el8.tourguide.Slide({
        name: 'reportsOverlay',
        showFn: function() {
            reportsOverlayWidget.show({
                contentFn: el8.template.tourguide.tease.reportsOverlay,
                height: 85,
                width: 310,
                right: '0px',
                top: 49,
                zIndex: 5000
            });
            reportsOverlayShade.show($('body'), {'opacity': 0.7, 'zIndex': 100, 'top': el8Globals['TOUR_VISOR_HEIGHT'], 'backgroundColor': 'black'});
        },
        hideFn: function() {
            reportsOverlayWidget.hide();
            reportsOverlayShade.hide();
        },
        eventToSlideNameMap: {
            'hide-reports-overlay': null // calls next()
        }
    });
    guide.addSlide(slideReportsOverlay);

    /**
     * Slide: Search for text again (after clear)
     */
    var searchTextWidget = new el8.tourguide.InfoBox();
    var slideSearchText = new el8.tourguide.Slide({
        navCaption: '3. Search Free-Text',
        name: 'searchText',
        showFn: function() {
            var $elt = $('#chart-feed-search-input');
            el8.appchart.mainFeeds.chart.doChartSearch('');
            searchTextWidget.show({
                contentFn: function() {
                    return el8.template.tourguide.tease.searchFreeText();
                },
                height: 140,
                width: 250,
                left: $elt.parent().offset().left - 250 - 20,
                top: $elt.parent().offset().top - 10
            });
            $elt.blur();
        },
        hideFn: function() {
            searchTextWidget.hide();
        },
        eventToSlideNameMap: {
            'submit-chart-feed-search': 'searchInProgress'
        }
    });
    guide.addSlide(slideSearchText);

    /**
     * Slide: Search for text again (after failure)
     */
    var searchTextAgainInfoBox = new el8.tourguide.InfoBox();
    var slideSearchTextAgain = new el8.tourguide.Slide({
        name: 'searchTextAgain',
        showFn: function() {
            var $elt = $('#chart-feed-search-input');
            searchTextAgainInfoBox.show({
                contentFn: el8.template.tourguide.tease.searchTextAgain,
                height: 75,
                width: 250,
                left: $elt.parent().offset().left,
                top: $elt.parent().offset().top + $elt.parent().outerHeight(true) + 10
            });
            el8.appchart.mainFeeds.chart.focusInput();
        },
        hideFn: function() {
            searchTextAgainInfoBox.hide();
        },
        eventToSlideNameMap: {
            'submit-chart-feed-search': 'searchInProgress'
        }
    });
    guide.addSlide(slideSearchTextAgain);

    /**
     * Slide: Blank slide while search is happening
     */
    var searchInProgressShade = new el8.tourguide.Shade();
    var searchInProgressSlide = new el8.tourguide.Slide({
        name: 'searchInProgress',
        showFn: function() {
            searchInProgressShade.show($('body'), {'opacity': 0, 'zIndex': 5, 'top': el8Globals['TOUR_VISOR_HEIGHT'], 'backgroundColor': 'black'});
        },
        hideFn: function() {
            searchInProgressShade.hide();
        },
        eventToSlideNameMap: {
            'successful-chart-feed-search': 'searchResults',
            'failed-chart-feed-search': 'searchTextAgain',
            'cleared-chart-feed-search': 'searchText'
        }
    });
    guide.addSlide(searchInProgressSlide);

    /**
     * Slide: Search results
     */
    var searchResultsWidget = new el8.tourguide.InfoBox();
    var searchResultsHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var searchResultsScrollFn = null;
    var searchResultsSlide = new el8.tourguide.Slide({
        name: 'searchResults',
        showFn: function() {
            setNoItemDetail(true);
            var $chartFeed = $('#chart-feed-list');
            var $magicTable = $('#lab-results-table-holder');
            searchResultsWidget.show({
                contentFn: el8.template.tourguide.tease.searchResults,
                height: 95,
                width: 250,
                left: $chartFeed.offset().left - 250 - 13,
                top: $chartFeed.offset().top
            });
            var showHilite = function() {
                var $navigator =
                    $('.chart-feed-navigator', $('#chart-feed-navigator-holder'));
                var topBuffer = 0;
                var magicTableOffset = $magicTable.outerHeight(true) + 20;
                if ($navigator.offset().top + $navigator.outerHeight(true)
                        > $chartFeed.offset().top - magicTableOffset) {
                    topBuffer = -1*($navigator.offset().top
                        + $navigator.outerHeight(true) - $chartFeed.offset().top);
                } else {
                    topBuffer += magicTableOffset;
                }
                searchResultsHilite.show($chartFeed, el8Globals['TOUR_VISOR_HEIGHT'],
                    {'top': topBuffer},
                    {'right': 15},
                    {'east': true, 'south': true}
                );
                searchResultsWidget.adjustOffsets(
                    {'top': $chartFeed.offset().top - topBuffer}
                );
            };
            showHilite();
            searchResultsScrollFn = _.throttle(function() {
                searchResultsHilite.hide();
                showHilite();
            }, 100);
            $('#main-feed-container').on('scroll', searchResultsScrollFn);
        },
        hideFn: function() {
            searchResultsWidget.hide();
            searchResultsHilite.hide();
            noItemDetail = false;
            $('#main-feed-container').unbind('scroll', searchResultsScrollFn);
        }
    });
    guide.addSlide(searchResultsSlide);

    /**
     * Slide: Clear Search
     */
    var clearSearchWidget = new el8.tourguide.InfoBox();
    var clearSearchHilite = new el8.tourguide.HiliteAction({'zIndex': 4});
    var slideClearSearch = new el8.tourguide.Slide({
        name: 'clearSearch',
        showFn: function() {
            $('#main-feed-container').css({'overflow': 'hidden'});
            var showIt = function() {
                var $elt = $('#chart-feed-search-input');
                var widgetWidth = 320;
                clearSearchWidget.show({
                    contentFn: el8.template.tourguide.tease.clearSearch,
                    height: 70,
                    width: widgetWidth,
                    left: $elt.offset().left + $elt.width() - (widgetWidth - 50),
                    top: $elt.offset().top + $elt.outerHeight(true) + 14
                });
                clearSearchHilite.show($elt, el8Globals['TOUR_VISOR_HEIGHT'], {
                    top: 2,
                    bottom: 5,
                    right: 5,
                    left: 5
                });
                $('#chart-feed-search-input').blur().prop('disabled', true);
            };
            showIt();
        },
        hideFn: function() {
            clearSearchWidget.hide();
            clearSearchHilite.hide();
            setNoItemDetail(false);
            $('#chart-feed-search-input').prop('disabled', false);
            $('#main-feed-container').css({'overflow': 'auto'});
        },
        eventToSlideNameMap: {
            'successful-chart-feed-search': 'clearSearch',
            'failed-chart-feed-search': 'clearSearch',
            'cleared-chart-feed-search': 'endTour'
         }
    });
    guide.addSlide(slideClearSearch);

    /**
     * Slide: End of tour!
     */
    var endSplash = new el8.tourguide.Splash({
        topOffset: el8Globals['TOUR_VISOR_HEIGHT'],
        opacity: 0.7,
        zIndex: 5,
        backgroundColor: 'black',
        contentFn: el8.template.tourguide.tease.endSplash,
        clickTriggerMap: {
            '.end-trigger': function(e) {
                guide.end();
                endSplash.hide();
                $(document).trigger('explore-search');
            }
        }
    });
    var slideEndTour = new el8.tourguide.Slide({
        name: 'endTour',
        showFn: function() {
            endSplash.show();
        },
        hideFn: function() {
            endSplash.hide();
        }
    });
    guide.addSlide(slideEndTour);


    /**
     * Add custom trigger bindings
     */
    $(document).on('chart-splash-close', function() {
        hideChartInfoBox();
        guide.start();
    });
    $(document).on('show-learn-more', function(e) {
        if (!guide.isInProgress()) { endSplash.show(); }
        return false;
    });
    $(document).on('show-item-detail', function(e, item) {
                if (!noItemDetail) {
            el8.appchart.showItemDetail(item); // either item or itemId
        }
        return false;
    });
    $(document).on('explore-search', function(e) {
        if (!guide.isInProgress()) {
            showSearchInfoBox();
            $(document).on('submit-chart-feed-search', function(e) {
                hideSearchInfoBox();
                $(document).unbind('submit-chart-feed-search');
            });
        }
    });
    $(document).on('click', '.next-trigger', function(e) {
        guide.next();
    });
    $(document).on('click', '.prev-trigger', function(e) {
        guide.previous();
    });

    $(document).on('click', '.create-test-account', function(e) {
        // we used to track in mixpanel
        return true;
    });
    $(document).on('click', '.contact-us', function(e) {
        // we used to track in mixpanel
        return true;
    });

    $(document).on('click', '.tour-end-trigger', function(e) {
                guide.end();
        endSplash.hide();
        return false;
    });
    $(document).on('click', '.tour-restart-trigger', function(e) {
        guide.end();
        endSplash.hide();
        el8.tourguide.chartInfoSplash.show(); // closing will trigger guide.start()
        showChartInfoBox();
        return false;
    });

    function hoverTimelineInfoBox() {
        $(document).on('mouseenter', '#chart-feed-visual', function() {
            showTimelineInfoBox();
        }).on('mouseleave', '#chart-feed-visual', function() {
            hideTimelineInfoBox();
        });
    }

    function unhoverTimelineInfoBox() {
        $(document).off('mouseenter', '#chart-feed-visual')
                   .off('mouseleave', '#chart-feed-visual');
    }

    return guide;

})();
